import { render, staticRenderFns } from "./OsQuestionnaireQuestionLocalizer.vue?vue&type=template&id=45d3df48&scoped=true"
import script from "./OsQuestionnaireQuestionLocalizer.vue?vue&type=script&lang=ts"
export * from "./OsQuestionnaireQuestionLocalizer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d3df48",
  null
  
)

export default component.exports